import { render, staticRenderFns } from "./FirmRecordProcess.vue?vue&type=template&id=4ce9087f"
import script from "./FirmRecordProcess.vue?vue&type=script&lang=js"
export * from "./FirmRecordProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports